import { SET_ARTICLE_LIST_DATA } from '../actions/ArticleListAction';

const uploadState = {
	articleListData: [],
}

export function ArticleReducer(state = uploadState, action) {
	if(action.type === SET_ARTICLE_LIST_DATA) {
		return {
			...state,
			articleListData: action.payload,
		}
	}
	return state;
}